import testControl from "./testControl.js"
 
export default {
    install : (app) => {
        app.config.globalProperties.$testControl = testControl
    }
}